import React from "react";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { classNames } from "primereact/utils";
import { useCalendarDownload } from "../../infrastructure/hooks/useCalendarDownload";
import styles from "./AddToCalendarButton.module.scss";

export interface IAddToCalendarButtonProps {
  reservationId?: number;
  className?: string;
  disabled?: boolean;
}

/**
 * Button component for downloading calendar (.ics) files for reservations
 */
export const AddToCalendarButton: React.FC<IAddToCalendarButtonProps> = ({
  reservationId,
  className,
  disabled = false,
}) => {
  const { downloadCalendar, isDownloading } = useCalendarDownload();

  const handleClick = async () => {
    if (!reservationId || isDownloading) {
      return;
    }

    await downloadCalendar(reservationId);
  };

  const isDisabled = disabled || !reservationId || reservationId <= 0 || isDownloading;

  return (
    <button
      className={classNames(styles.button, className, {
        [styles.buttonDisabled]: isDisabled,
        [styles.buttonLoading]: isDownloading,
      })}
      onClick={handleClick}
      disabled={isDisabled}
      type="button"
      aria-label="Добави в календара"
    >
      {isDownloading ? (
        <div className={styles.loadingContainer}>
          <ProgressSpinner
            className={styles.spinner}
            style={{ width: "20px", height: "20px" }}
            strokeWidth="4"
          />
          <span className={styles.buttonText}>Зареждане...</span>
        </div>
      ) : (
        <>
          <span className={styles.buttonIcon}>📅</span>
          <span className={styles.buttonText}>Добави в календара</span>
        </>
      )}
    </button>
  );
};
